import { Box, Typography, Paper } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'

/**
 * Página de Permissões por grupo e usuário.
 * Administra permissões para a empresa escolhida.
 * Implementação completa em desenvolvimento.
 */
const PermissoesPage: React.FC = () => {
  const { getEmpresaId } = useAuth()
  const empresaId = getEmpresaId()

  return (
    <Box sx={{ py: 4, px: { xs: 2, md: 3 }, width: '100%' }}>
      <Typography variant="h5" gutterBottom>
        Permissões por grupo e usuário
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Administrar permissões por grupo e usuário para a empresa escolhida.
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1" color="text.secondary">
          {empresaId
            ? `Empresa selecionada: ${empresaId}. Tela em construção — em breve será possível gerenciar permissões por grupo e usuário para cada empresa.`
            : 'Selecione uma empresa no contexto para continuar.'}
        </Typography>
      </Paper>
    </Box>
  )
}

export default PermissoesPage
